import { useState } from 'react';
import { X } from 'lucide-react';
import { Button, Input } from '@app/components/ui';

interface SectionManagerProps {
  sections: string[];
  onAddSection: (name: string) => void;
  onRemoveSection: (name: string) => void;
}

/** The section names a setlist's songs can be grouped under (Opening, Communion...). */
export const SectionManager: React.FC<SectionManagerProps> = ({ sections, onAddSection, onRemoveSection }) => {
  const [newSectionName, setNewSectionName] = useState('');

  const handleAdd = () => {
    const name = newSectionName.trim();
    if (!name) return;
    onAddSection(name);
    setNewSectionName('');
  };

  return (
    <div className="border-t border-line pt-3">
      <div className="wp-eyebrow mb-2">Sections</div>
      {sections.length > 0 && (
        <ul className="flex flex-wrap gap-1.5 mb-2.5" aria-label="Sections">
          {sections.map((s) => (
            <li key={s} className="inline-flex items-center gap-1 pl-2.5 pr-1 h-7 text-[12.5px] font-medium bg-fill2 text-t2 rounded-full">
              {s}
              <button
                type="button"
                onClick={() => onRemoveSection(s)}
                aria-label={`Remove section ${s}`}
                className="w-5 h-5 rounded-full text-t4 hover:text-acc hover:bg-acc-bg flex items-center justify-center"
              >
                <X size={11} aria-hidden="true" />
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className="flex items-center gap-2">
        <div className="flex-1">
          <Input
            height={36}
            aria-label="New section name"
            value={newSectionName}
            onChange={(e) => setNewSectionName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
            placeholder="New section name..."
            className="!text-[13px]"
          />
        </div>
        <Button variant="ghost" size="sm" className="!h-9" onClick={handleAdd} disabled={!newSectionName.trim()}>
          Add section
        </Button>
      </div>
    </div>
  );
};
